import React, { useEffect, useRef, useState } from 'react';
import { motion, useInView } from 'framer-motion';

const Index = ({
  firstHeading,
  secondHeading,
  _class,
  _secondHeading,
  subTitle,
  headingThree,
  headingTwo,
  headingOne,
  _spanClass,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.25 });
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768); // Standard mobile breakpoint
    };

    // Initial check
    checkScreenSize();

    // Add event listener
    window.addEventListener('resize', checkScreenSize);

    // Cleanup
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Process heading content based on screen size
  const processHeading = (content) => {
    if (!content) return '';
    if (isMobile) {
      // Remove <br> tags on mobile and replace with space
      return content.replace(/<br\s*\/?>/gi, ' ');
    }
    return content;
  };

  const processedHeading = secondHeading ? processHeading(secondHeading) : '';

  const HeadingComponent = headingOne
    ? 'h1'
    : headingTwo
    ? 'h2'
    : headingThree
    ? 'h3'
    : 'h2';

  const words = processedHeading ? processedHeading.split(' ') : [];

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const wordVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
   <>
   {(firstHeading || secondHeading || subTitle) && (
  <div className={`title ${_class}`} ref={ref}>
    {firstHeading && (
      <span
        className={`miniheading ${_spanClass}`}
        data-aos="zoom-in"
        data-aos-offset="100"
        data-aos-duration="500"
        data-aos-once="true"
        data-aos-easing="ease-in-sine"
        dangerouslySetInnerHTML={{ __html: firstHeading }}
      />
    )}

    {processedHeading && (
      <motion.div
        className={`heading headingColor ${_secondHeading}`}
        variants={containerVariants}
        initial="hidden"
        animate={isInView ? 'visible' : 'hidden'}
      >
        {words.map((word, index) => (
          <motion.span
            key={index}
            variants={wordVariants}
            dangerouslySetInnerHTML={{
              __html: word + (index < words.length - 1 ? ' ' : ''),
            }}
            style={{ display: 'inline' }}
          />
        ))}
      </motion.div>
    )}

    {subTitle && (
      <p
        className="col-12 float-start mb-0"
        data-aos="fade-up"
        data-aos-offset="50"
        data-aos-duration="800"
        data-aos-once="true"
        data-aos-easing="ease-in-sine"
        dangerouslySetInnerHTML={{ __html: subTitle }}
      />
    )}
  </div>
)}

   </>
  );
};

export default Index;
